import React, { useState, useEffect } from 'react';
import { Modal as ModalPopup } from 'react-bootstrap';
import { I18n } from '../../../helpers/i18n';
import { requestUserDetailBySession } from '../../../redux/actions/mvp/session.action';
import { isMvpUserGuide } from '../../../helpers/mvpAuth';
import { formatRating, maskUserName, getAgeAndBirthYear } from '../../../helpers/utils';
import RatingListItem from './RatingListItem';
import starActive from '../../../static/images/mvp/star_active.png';
import './RatingListModal.css';
import './UsersRatingListModal.css';

function UsersRatingListModal({ visible, sessionId, userId, onClose, user }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !sessionId || !userId) return;

    setLoading(true);
    const role = isMvpUserGuide(user) ? 'senior' : 'guide';
    requestUserDetailBySession({ sessionId, userId, role })
      .then((response) => {
        setData(response);
      })
      .catch(() => {
        setData(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [visible, sessionId, userId, user]);

  const ratings = data?.listRatings || [];
  const avgRating = data?.avgRating ?? 0;
  const totalRating = data?.totalRating ?? 0;
  const buddyName = loading ? '' : data?.name || I18n.t('buddy_ratings_title');
  // Explorer đang xem profile Guide → tiêu đề "Guide {name}". Guide đang xem Explorer → "Explorer {name}".
  const viewerIsGuide = isMvpUserGuide(user);
  const ratedUserRoleLabel = viewerIsGuide
    ? I18n.t('account_type_selection_senior')
    : I18n.t('account_type_selection_senior_buddy');
  const reviewerRoleLabel = viewerIsGuide
    ? I18n.t('account_type_selection_senior_buddy')
    : I18n.t('account_type_selection_senior');
  const ageAndYear = getAgeAndBirthYear(data?.dob);
  const subtitle = ageAndYear
    ? I18n.t('buddy_modal_age_born_year', { age: ageAndYear.age ?? '*', year: ageAndYear.year })
    : null;

  return (
    <ModalPopup
      size="lg"
      show={visible}
      onHide={onClose}
      id="rating-list-modal"
      className="user-rating-modal"
      centered
      style={{ opacity: 1 }}
    >
      <div className="rating-list-modal-header">
        <div className="rating-list-modal-header-row">
          <span className="rating-list-modal-close" onClick={onClose}>
            ✕
          </span>
          <span className="rating-list-modal-header-title">
            {ratedUserRoleLabel} {buddyName}
          </span>
        </div>
        {subtitle && <div className="rating-list-modal-header-subtitle">{subtitle}</div>}
      </div>
      <ModalPopup.Body>
        <div className="rating-list-modal-content">
          {totalRating > 0 && (
            <div className="rating-list-summary">
              <img src={starActive} className="rating-list-summary-star-image" alt="" />
              <span className="rating-list-summary-score">{formatRating(avgRating)}</span>
              <span className="rating-list-summary-separator">•</span>
              <span className="rating-list-summary-count">
                {totalRating.toLocaleString()} {I18n.t('ratings_count')}
              </span>
            </div>
          )}

          {loading ? (
            <div className="rating-list-loading">...</div>
          ) : ratings.length === 0 ? (
            <div className="rating-list-empty">{I18n.t('no_rating')}</div>
          ) : (
            <div className="rating-list-items">
              {ratings.map((item, index) => {
                const evaluation = item.evaluation || item;
                return (
                  <RatingListItem
                    key={index}
                    roleLabel={reviewerRoleLabel}
                    name={maskUserName(item.name)}
                    score={evaluation.score}
                    time={evaluation.time}
                    sessionTitle={evaluation.sessionTitle}
                    contentExtra={evaluation.contentExtra}
                    content={evaluation.content}
                  />
                );
              })}
            </div>
          )}
        </div>
      </ModalPopup.Body>
    </ModalPopup>
  );
}

export default UsersRatingListModal;
